{
  "goal": "Objectif",
  "subAccount": "Sous-compte",
  "any": "Tous",
  "table": {
    "client": "Client",
    "type": "Modèle Type de portefeuille",
    "goal": "Objectif",
    "accounts": "Compte(s)",
    "portfolioValue": "Balance de portefeuille",
    "driftRebalanceRequired": "Déclencheur de dérive",
    "internalDriftTrigger": "Déclencheur de dérive interne",
    "liquidateRebalanceRequired": "Déclenchement de la liquidation",
    "cashTrigger": "Déclenchement des liquidités",
    "tradeRequests": "Demandes d'échange",
    "updatedAt": "Dernière mise à jour",
    "organization": "Organisation",
    "cashAvailableForTrade": "Argent disponible pour les opérations",
    "expectedCash": "Liquidités attendues",
    "pendingCash": "Liquidités en attente",
    "difference": "Différence requise",
    "cashPercentage": "Pourcentage de liquidités",
    "portfolio": "Portefeuilles modèles",
    "totalMarketValue": "Valeur marchande totale",
    "tradeVerificationRequired": "Vérification commerciale requise",
    "bulkTradeRequired": "Demande d'échanges groupés"
  },
  "tooltips": {
    "cashAvailableForTrade": "Il s'agit de vos échanges sans espèces qui sont en cours de traitement",
    "pendingCash": "Il s'agit de vos liquidités en attente",
    "UNPAIRED": "Échanges requis",
    "ILLIQUID": "Produit non-liquide",
    "UNBLOCKED_BUYS": "Achats débloqués",
    "PAIRED": "Associé"
  },
  "types": {
    "GOAL": "Objectif",
    "SUB_ACCOUNT": "Sous-compte",
    "HOUSEHOLD": "Ménage"
  },
  "goalType": {
    "CAR": "Voiture",
    "BUILD_WEALTH": "Bâtir vos avoirs",
    "RETIREMENT": "Retraite",
    "MAJOR_PURCHASE": "Achat majeur",
    "HOUSE": "Maison",
    "EDUCATION": "Éducation",
    "VACATION": "Vacances",
    "START_A_BUSINESS": "Lancer une entreprise",
    "WEDDING": "Mariage",
    "PARENTAL_LEAVE": "Congé parental",
    "SAFETY_NET": "Filet de sécurité",
    "OTHER": "Autre",
    "CASH_RESERVE": "Réserve de trésorerie",
    "LEGACY": "Héritage",
    "GROUP": "Groupe",
    "RETIREMENT_INCOME": "Revenu de retraite"
  },
  "filters": {
    "selectOrganization": "Sélectionner l'organisation",
    "modalportfolioType": "Modèle Type de portefeuille",
    "selectPortfolio": "Sélectionner un modèle de portefeuille",
    "selectAccountType": "Sélectionner le type de compte",
    "selectAccount": "Sélectionner un compte",
    "triggerType": "Type de déclencheur",
    "driftRebalance": "Dérive",
    "internalDrift": "Dérive interne",
    "cash": "Argent",
    "liquidateRebalance": "Liquidation Rééquilibrage uniquement",
    "anyRebalanceRequired": "Rééquilibrage nécessaire",
    "tradeRequests": "Demandes d'échange",
    "yes": "Oui",
    "no": "Non",
    "bulkTradeRequiredReason": "Motif de la demande d'échanges groupés",
    "status": "Statut",
    "active": "Actif",
    "inactive": "Inactif",
    "value": "Valeur",
    "zero": "0$",
    "greaterThanZero": "Supérieur à 0$",
    "tradeVerificationStatus": "Vérification commerciale requise",
    "verified": "Vérifié",
    "unverified": "Non vérifié"
  },
  "household": "Ménage"
}
